module.exports = __webpack_public_path__ + "img/groupworks@3x.d11ffc0b.png";